module.exports = __webpack_public_path__ + "img/my.eca9c2af.png";